module.exports = __webpack_public_path__ + "media/applicants/accountinfo-1de1e3e7.png";